import { Title } from '@winnin/winnin_ui.components.title'

import { ReactComponent as EmptyNiche } from 'assets/images/svg/topics/empty-niche.svg'
import { useTranslate } from 'lib/tolgee'

import TOLGEE_KEYS from './niche-empty-state.i18n'
import type { INicheEmptyState } from './niche-empty-state.types'

import './niche-empty-state.styles.scss'

export function NicheEmptyState({ contextName, isDefaultContext }: INicheEmptyState) {
  const t = useTranslate()

  return (
    <div className="EmptyStateNiches">
      <EmptyNiche />

      <div className="EmptyStateNiches-content">
        <Title tag="h3" weight="semi">
          {t(TOLGEE_KEYS.contextName({ contextName: contextName }))}
        </Title>
        <p>
          {t(TOLGEE_KEYS.contextNameDescription)}
          {!isDefaultContext && <> {t(TOLGEE_KEYS.contextNameSuggestion)}</>}
        </p>
      </div>
    </div>
  )
}
